<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">
              Transportadora
              <v-btn
                depressed
                small
                color="error"
                v-on:click="logout()"
                class="btn-logout"
              >
                <v-icon>exit_to_app</v-icon>Sair
              </v-btn>
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-row no-gutters v-if="transportadora">
                <v-col :md="12" :sm="12" :xs="12" cols="12">
                  <strong class="info-text">
                    Razão Social:
                    <em>{{ transportadora.razaosocial }}</em>
                  </strong>
                </v-col>
                <v-col
                  :md="12"
                  :sm="12"
                  :xs="12"
                  cols="12"
                  class="mt-2 text-md-left"
                >
                  <strong class="info-text">
                    CNPJ:
                    <em>{{ transportadora.cnpj | cnpj }}</em>
                  </strong>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title"
              >Relatório de Frota - Auto de Infração</v-card-title
            >
            <v-card-text class="app-card-content">
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-select
                      v-model="form.tipo"
                      :items="tiposRelatorio"
                      :item-text="'name'"
                      :item-value="'id'"
                      :rules="[rules.required]"
                      label="Tipo Relatório*"
                      placeholder="Selecione o tipo de relatório"
                      filled
                      rounded
                      dense
                    ></v-select>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.placa"
                      type="text"
                      label="Placa"
                      placeholder="Ex.: GDX-1B34"
                      v-mask="'AAA-#X##'"
                      class="placa"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="6" :sm="6" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.dataInicio"
                      type="text"
                      label="Data Início"
                      v-mask="'##/##/####'"
                      placeholder="Ex.: 10/02/2018"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="6" :sm="6" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.dataFim"
                      type="text"
                      label="Data Fim"
                      v-mask="'##/##/####'"
                      placeholder="Ex.: 10/02/2018"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12" class="pt-0">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input
                      v-model="form.recaptcha"
                      type="hidden"
                      :rules="[rules.required]"
                      style="margin-top: -25px;"
                    ></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12" class="pt-0">
                    <v-btn depressed block large color="primary" type="submit"
                      >Continuar</v-btn
                    >
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular
                  :size="25"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";

import { relatorio_frota_tipo } from "@/models/relatorio_frota_tipo";

import TransportadoraAuthService from "@/services/transportadora.auth.service";

import ReportService from "@/services/report.service";

export default {
  metaInfo: {
    title: "Relatório de Frota - Auto de Infração - Central de Serviços"
  },
  components: {
    VueRecaptcha
  },
  directives: {
    mask
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      tiposRelatorio: relatorio_frota_tipo,
      transportadora: null,
      form: {
        tipo: null,
        cnpj: null,
        token: null,
        recaptcha: null,
        placa: null,
        dataInicio: null,
        dataFim: null,
        numOrdem: null
      },
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido"
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        const {
          tipo,
          cnpj,
          recaptcha,
          placa,
          dataInicio,
          dataFim, 
          numOrdem
        } = this.form;
        this.isLoading = true;
        ReportService.relatorioFrotaAutoInfracao(
          tipo,
          cnpj,
          recaptcha,
          placa,
          dataInicio,
          dataFim,
          numOrdem
        ).subscribe(
          res => {
            const filename = `RelatorioDeFrotaAutoInfracao_${cnpj}.pdf`;
            this.download(res, filename);
            this.isLoading = false;
            this.expiredRecaptcha();
          },
          error => {
            this.expiredRecaptcha();
            this.isLoading = false;
          }
        );
      }
    },
    download: (res, filename) => {
      const file = new Blob([res], {
        type: "application/pdf",
        fileName: "CertificadoRegistroVeiculo"
      });
      const fileURL = URL.createObjectURL(file);
      let a = document.createElement("a");
      a.href = fileURL;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(fileURL);
    },
    logout() {
      TransportadoraAuthService.logout();
    },
    getCurrentTransportadora() {
      this.transportadora =
        TransportadoraAuthService.currentTransportadoraValue;

      this.form.cnpj = this.transportadora.cnpj;
      this.form.token = this.transportadora.token;
      this.form.numOrdem = this.transportadora.numOrdem;

    }
  },
  mounted() {
    this.getCurrentTransportadora();
  }
};
</script>

<style></style>
